import { useTranslationEditor } from './TranslationEditorContext';

export function useEditTranslationsToggle(onToggled: () => void) {
    const { editTranslationsEnabled, enableEditTranslations, disableEditTranslations } =
        useTranslationEditor();

    function toggle() {
        if (editTranslationsEnabled) {
            disableEditTranslations();
        } else {
            enableEditTranslations();
        }
        onToggled();
    }

    return { editTranslationsEnabled, toggle };
}
